import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"

import Layout from "../components/layout"
import SEO from "../components/seo"

import './blog-post.css';

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata.title
  // TODO: implement previous/next links
  const { previous, next } = pageContext

  function findImages(children) {
    let res = []

    children.forEach(c => {
      if(c.children) { res = res.concat(findImages(c.children)) }
      if(c.tagName === 'img') {
        res = res.concat(c)
      }
    })

    return res
  }

  return (
    <Layout location={location} title={siteTitle} cssClass="blog-post">
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        featuredImage={findImages(data.markdownRemark.htmlAst.children)[0]}

      />
      <article>
        <header>
          <h1 >
            {post.frontmatter.title}
          </h1>
          <p >
            {post.frontmatter.date}
          </p>
        </header>
        <section dangerouslySetInnerHTML={{ __html: post.html }} />
      </article>

      {/*
      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
      */}
    </Layout>
  )
}

BlogPostTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      htmlAst
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`
